module.exports = __webpack_public_path__ + "static/media/towing_services_md.a3f18602.png";